import { AfterViewInit, Component, ElementRef, HostListener, Input, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ZoomParametersViewModel } from '../../../view-models/zoom/zoom-parameters-view-model';
import { StringZoomPropertyViewModel } from '../../../view-models/zoom/property-view-model/string-zoom-property-view-model';
import { NumericZoomPropertyViewModel } from '../../../view-models/zoom/property-view-model/numeric-zoom-property-view-model';
import { ZoomFilterViewModel } from '../../../view-models/zoom/filter-view-model/zoom-filter-view-model';
import { trigger, transition, style, animate } from '@angular/animations';
import { BoolZoomPropertyViewModel } from '../../../view-models/zoom/property-view-model/bool-zoom-property-view-model';
import { DateTimeZoomPropertyViewModel } from '../../../view-models/zoom/property-view-model/date-time-zoom-property-view-model';
import { DateTimeOffsetZoomPropertyViewModel } from '../../../view-models/zoom/property-view-model/date-time-offset-zoom-property-view-model';
import { EnumZoomPropertyViewModel } from '../../../view-models/zoom/property-view-model/enum-zoom-property-view-model';
import { CollapsableFilterViewModelInterface } from '../../../view-models/zoom/filter-view-model/collapsable-filter-view-model.interface';
import { GuidZoomPropertyViewModel } from '../../../view-models/zoom/property-view-model/guid-zoom-property-view-model';
import { TextButtonComponent } from '../../shared/buttons/text-button/text-button.component';
import { AsyncPipe, CommonModule, NgClass } from '@angular/common';
import { ZoomAvailablesFilterPipe } from '../zoom-availables-filter.pipe';
import { ZoomFilterStringTextBoxComponent } from '../core/zoom-filter-string-text-box/zoom-filter-string-text-box.component';
import { ZoomFilterNumericTextBoxComponent } from '../core/zoom-filter-numeric-text-box/zoom-filter-numeric-text-box.component';
import { ZoomFilterBoolTextBoxComponent } from '../core/zoom-filter-bool-text-box/zoom-filter-bool-text-box.component';
import { ZoomFilterDateTextBoxComponent } from '../core/zoom-filter-date-text-box/zoom-filter-date-text-box.component';
import { ZoomFilterDateOffsetTextBoxComponent } from '../core/zoom-filter-date-offset-text-box/zoom-filter-date-offset-text-box.component';
import { ZoomFilterEnumTextBoxComponent } from '../core/zoom-filter-enum-text-box/zoom-filter-enum-text-box.component';
import { ZoomParametersSortingGroupsComponent } from '../zoom-parameters-sorting-groups/zoom-parameters-sorting-groups.component';
import { BaseEnumTextBoxComponent } from '../../controls/core/base/base-enum-text-box/base-enum-text-box.component';
import { NTSTranslatePipe } from '../../pipe/nts-translation-pipe';
import { LabelBoxComponent } from '../../controls/core/base/label-box/label-box.component';
import { BaseCheckboxTextBoxComponent } from '../../controls/core/base/base-checkbox-text-box/base-checkbox-text-box.component';
import { ZoomFilterOperatorTextBoxComponent } from '../zoom-parameters/zoom-filter-operator-text-box.component';
import { FilledButtonType, FilterOperators } from '@nts/std/types';
import { ExternalZoomPropertyViewModel } from '../../../view-models/zoom/property-view-model/external-zoom-property-view-model';
import { ZoomFilterExternalTextBoxComponent } from '../core/zoom-filter-external-text-box/zoom-filter-external-text-box.component';
import { BoolZoomFilterViewModel } from '../../../view-models/zoom/filter-view-model/bool-zoom-filter-view-model';
import { EnumZoomFilterViewModel } from '../../../view-models/zoom/filter-view-model/enum-zoom-filter-view-model';
import { ExternalZoomFilterViewModel } from '../../../view-models/zoom/filter-view-model/external-zoom-filter-view-model';
import { DateTimeZoomFilterViewModel } from '../../../view-models/zoom/filter-view-model/date-time-zoom-filter-view-model';
import { NumericZoomFilterViewModel } from '../../../view-models/zoom/filter-view-model/numeric-zoom-filter-view-model';
import { StringZoomFilterViewModel } from '../../../view-models/zoom/filter-view-model/string-zoom-filter-view-model';
import { GuidZoomFilterViewModel } from '../../../view-models/zoom/filter-view-model/guid-zoom-filter-view-model';

@Component({
  selector: 'nts-zoom-parameters-mobile',
  templateUrl: './zoom-parameters-mobile.component.html',
  styleUrls: ['zoom-parameters-mobile.component.scss'],
  imports: [
    TextButtonComponent,
    NgClass,
    ZoomAvailablesFilterPipe,
    ZoomFilterOperatorTextBoxComponent,
    ZoomFilterStringTextBoxComponent,
    ZoomFilterNumericTextBoxComponent,
    ZoomFilterBoolTextBoxComponent,
    ZoomFilterDateTextBoxComponent,
    ZoomFilterDateOffsetTextBoxComponent,
    ZoomFilterEnumTextBoxComponent,
    ZoomFilterExternalTextBoxComponent,
    BaseEnumTextBoxComponent,
    ZoomParametersSortingGroupsComponent,
    NTSTranslatePipe,
    LabelBoxComponent,
    BaseCheckboxTextBoxComponent,
    AsyncPipe,
    CommonModule
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  animations: [
    trigger('openClose', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('0.5s', style({ opacity: 1 })),
      ])
    ])
  ]
})
export class ZoomParametersMobileComponent implements OnInit, AfterViewInit {

  @Input()
  zoomParametersViewModel: ZoomParametersViewModel;

  private _rowToSetFocus = -1;
  filledButtonTypeEnum = FilledButtonType;
  guidMaskSettings = {
    mask: '\\{********-****-****-****-************\\}',
    placeholderChar: 'X',
    lazy: false,
    hideMaskOnBlur: true,
    validateMaskOnBlurFunc: (valueToValidate: string) => {
      return /^[{]?[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}[}]?$/.test(valueToValidate);
    }
  };

  @ViewChild('parameterLabels', { static: true }) parameterLabels: ElementRef;
  @ViewChild('parameterValues', { static: true }) parameterValues: ElementRef;

  constructor() {
  }

  @HostListener('keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.target.dispatchEvent(new Event('blur'));  // (<HTMLInputElement>event.target).blur();
      this.zoomParametersViewModel.findEmitted.next();
    }
  }

  ngOnInit() {
    if (!this.zoomParametersViewModel) { throw new Error('Missing viewModel!'); }

    this._rowToSetFocus = this.zoomParametersViewModel.rowToSetFocus;
    this.zoomParametersViewModel.paramtersUpdated.subscribe(() => {
      this.setFocus();
    });

    // this.zoomNotifierService.startZoomRequested.subscribe((args: ZoomUIStarterArgs) => {
    //   this.setFocus();
    // });
  }

  hasChildren(filter: ZoomFilterViewModel) {
    return filter.children?.length > 0;
  }

  toggleChildrenVisibility(filter: CollapsableFilterViewModelInterface) {
    filter.toggleCollapsed();
  }

  toggleExpandedFilter(filter: CollapsableFilterViewModelInterface) {
    filter.toggleExpanded();
  }

  // STRING - PVM

  isFilterString(filterValue: unknown): filterValue is StringZoomPropertyViewModel {
    return filterValue instanceof StringZoomPropertyViewModel;
  }

  getFilterString(filterValue: unknown): StringZoomPropertyViewModel {
    if (this.isFilterString(filterValue)) {
      return filterValue;
    }
    return null;
  }

  // STRING - FVM

  isStringZoomFilterViewModel(filterValue: unknown): filterValue is StringZoomFilterViewModel {
    return filterValue instanceof StringZoomFilterViewModel;
  }

  // GUID - PVM

  isFilterGuid(filterValue: unknown): filterValue is GuidZoomPropertyViewModel {
    return filterValue instanceof GuidZoomPropertyViewModel;
  }

  // GUID - FVM

  isGuidZoomFilterViewModel(filterValue: unknown): filterValue is GuidZoomFilterViewModel {
    return filterValue instanceof GuidZoomFilterViewModel;
  }

  // NUMERIC - PVM

  isFilterNumeric(filterValue: unknown): filterValue is NumericZoomPropertyViewModel {
    return filterValue instanceof NumericZoomPropertyViewModel;
  }

  getFilterNumeric(filterValue: unknown): NumericZoomPropertyViewModel {
    if (this.isFilterNumeric(filterValue)) {
      return filterValue;
    }
    return null;
  }

  // NUMERIC - FVM

  isNumericZoomFilterViewModel(filterValue: unknown): filterValue is NumericZoomFilterViewModel {
    return filterValue instanceof NumericZoomFilterViewModel;
  }

  getNumericZoomFilterViewModel(filterValue: unknown): NumericZoomFilterViewModel {
    if (this.isNumericZoomFilterViewModel(filterValue)) {
      return filterValue;
    }
    return null;
  }

  // BOOL - PVM

  isFilterBool(filterValue: unknown): filterValue is BoolZoomPropertyViewModel {
    return filterValue instanceof BoolZoomPropertyViewModel;
  }

  // BOOL - FVM

  isBoolZoomFilterViewModel(filterValue: unknown): filterValue is BoolZoomFilterViewModel {
    return filterValue instanceof BoolZoomFilterViewModel;
  }

  getBoolZoomFilterViewModel(filterValue: unknown): BoolZoomFilterViewModel {
    if (this.isBoolZoomFilterViewModel(filterValue)) {
      return filterValue;
    }
    return null;
  }

  // DATE - PVM

  isFilterDate(filterValue: unknown): filterValue is DateTimeZoomPropertyViewModel {
    return filterValue instanceof DateTimeZoomPropertyViewModel;
  }

  getFilterDate(filterValue: unknown): DateTimeZoomPropertyViewModel {
    if (this.isFilterDate(filterValue)) {
      return filterValue;
    }
    return null;
  }

  isFilterDateTimeOffset(filterValue: unknown): filterValue is DateTimeOffsetZoomPropertyViewModel {
    return filterValue instanceof DateTimeOffsetZoomPropertyViewModel;
  }

  getFilterDateTimeOffset(filterValue: unknown): DateTimeOffsetZoomPropertyViewModel {
    if (this.isFilterDateTimeOffset(filterValue)) {
      return filterValue;
    }
    return null;
  }

  // DATE - FVM

  isDateTimeZoomFilterViewModel(filterValue: unknown): filterValue is DateTimeZoomFilterViewModel {
    return filterValue instanceof DateTimeZoomFilterViewModel;
  }

  getDateTimeZoomFilterViewModel(filterValue: unknown): DateTimeZoomFilterViewModel {
    if (this.isDateTimeZoomFilterViewModel(filterValue)) {
      return filterValue;
    }
    return null;
  }

  // ENUM - PVM

  isFilterEnum(filterValue: unknown): filterValue is EnumZoomPropertyViewModel {
    return filterValue instanceof EnumZoomPropertyViewModel;
  }

  // ENUM - FVM

  isEnumZoomFilterViewModel(filterValue: unknown): filterValue is EnumZoomFilterViewModel {
    return filterValue instanceof EnumZoomFilterViewModel;
  }

  getEnumZoomFilterViewModel(filterValue: unknown): EnumZoomFilterViewModel {
    if (this.isEnumZoomFilterViewModel(filterValue)) {
      return filterValue;
    }
    return null;
  }

  // EXTERNAL - PVM

  isFilterExternal(filterValue: unknown): filterValue is ExternalZoomPropertyViewModel {
    return filterValue instanceof ExternalZoomPropertyViewModel;
  }

  getExternalZoomPropertyViewModel(filterValue: unknown): ExternalZoomPropertyViewModel {
    if (this.isFilterExternal(filterValue)) {
      return filterValue;
    }
    return null;
  }

  // EXTERNAL - FVM

  isExternalZoomFilterViewModel(filterValue: unknown): filterValue is ExternalZoomFilterViewModel {
    return filterValue instanceof ExternalZoomFilterViewModel;
  }

  getExternalZoomFilterViewModel(filterValue: unknown): ExternalZoomFilterViewModel {
    if (this.isExternalZoomFilterViewModel(filterValue)) {
      return filterValue;
    }
    return null;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.setFocus();
    }, 700);
  }

  async findExternal(event, filter: ZoomFilterViewModel) {
    if (filter.externalDomainModelNameToZoom !== '' && filter.islocked === false && filter.isLoading$.value === false) {
      filter.isLoading$.next(true);
      this.parameterFocus(event, filter);
      filter.operator.currentValue = FilterOperators.Equals;
      if (this.zoomParametersViewModel.canFindExternal()) {
        await this.zoomParametersViewModel.findExternal();
        filter.isLoading$.next(false);
      }
    }
  }

  setFocus() {
    this._rowToSetFocus = this.zoomParametersViewModel.rowToSetFocus;
    if (this._rowToSetFocus >= 0 && this.zoomParametersViewModel.filters.length > this._rowToSetFocus) {
      // Focus cell
      // setTimeout(() => {
      //   this.filters.toArray()[this._rowToSetFocus].nativeElement.firstElementChild.firstElementChild.focus();
      // });
      // if ((this.zoomParametersViewModel.filters[this._rowToSetFocus].filterValue as ZoomPropertyViewModel<any>).enabled) {
      //   this.zoomParametersViewModel.filters[this._rowToSetFocus].filterValue.setFocus();
      // } else {
      if (this.zoomParametersViewModel.findCommand.isVisible$.value) {
        this.zoomParametersViewModel.findCommandFocus.next();
      }
      // }
    }
  }

  parameterFocus(ev: Event, filter: ZoomFilterViewModel) {
    this.zoomParametersViewModel.selectedZoomFilterViewModel = filter;
  }

  keyDown(ev: any) {
    if (ev.key === 'F6' && ev.ctrlKey) {
      if (this.zoomParametersViewModel.isActiveF6) {
        this.zoomParametersViewModel.findExternal();
      }
    }
  }
}
